__turbopack_context__.v({
  "action": "header-module-scss-module__iuiX6G__action",
  "header": "header-module-scss-module__iuiX6G__header",
  "headerTextContainer": "header-module-scss-module__iuiX6G__headerTextContainer",
  "hidden": "header-module-scss-module__iuiX6G__hidden",
  "loading": "header-module-scss-module__iuiX6G__loading",
});
